<template>
  <v-container fluid grid-list-lg>
    <v-layout align-center column overflow-hidden>
      <v-flex xs12 shrink>
        <h1 class="display-3 font-weight-black">Welcome</h1>
      </v-flex>
      <v-flex xs12 shrink>
        <img height="35px" src="@/assets/autoRepairLoogo.png" />
      </v-flex>

      <!-- <v-flex xs12 shrink class="black--text">
        let's Start
      </v-flex> -->

      <v-flex>
        <v-card v-if="stage === 1" flat class="outlined" width="600px">
          <v-container>
            <v-layout row wrap>
              <v-flex xs12>
                <h3>New Organization</h3>
                <h4 class="mb-3 font-weight-regular">
                  Enter your organization’s information. All your data will be associated with this organization,
                  regardless of whether you have one or multiple business locations.
                </h4>
              </v-flex>
              <v-flex xs12>
                <div>Organization Name</div>
                <v-text-field :background-color="`${Organization.name ? false : '#E8E2F2'}`" autofocus
                  label="Enter organization name" v-model="Organization.name" solo
                  :error-messages="organizationNameErrors"
                  :hide-details="organizationNameErrors.length === 0"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <div>Phone Number</div>
                <v-text-field :background-color="`${Organization.phoneNumber ? false : '#E8E2F2'}`"
                  v-model="Organization.phoneNumber" label="Enter phone number" solo
                  :error-messages="organizationPhoneNumberErrors"
                  :hide-details="organizationPhoneNumberErrors.length === 0" mask="phone">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <div>Email Address</div>
                <v-text-field :background-color="`${Organization.email ? false : '#E8E2F2'}`"
                  v-model="Organization.email" solo label="Enter email address"
                  :error-messages="organizationEmailErrors" :hide-details="organizationEmailErrors.length === 0">
                </v-text-field>
              </v-flex>
            </v-layout>



          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" large class="white-btn v-btn-with-radius" :disabled="$v.Organization.$invalid"
              @click="nextStage">continue</v-btn>
          </v-card-actions>
        </v-card>

        <v-card flat class="outlined" v-if="stage === 2">
          <v-container grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <h3>Your first location</h3>
                <p>
                  Provide the business information for the first location or storefront you’d like to start with.
                  If you’re signing up multiple locations, begin with the one you consider your main business and add
                  the
                  others after completing your organization setup.

                  <b>This information will appear on your business invoice receipts.</b>
                </p>
              </v-flex>

              <v-flex xs12 md6>
                <div>Business Name</div>
                <v-text-field solo :background-color="`${Location.name ? false : '#E8E2F2'}`" v-model="Location.name"
                  label="Enter business name" :hide-details="locationNameErrors.length === 0" ref="businessName"
                  :error-messages="locationNameErrors">
                </v-text-field>
              </v-flex>

              <v-flex xs12 md6>
                <div>Website</div>
                <v-text-field solo v-model="Location.website" label="Enter website address" hide-details>
                </v-text-field>
              </v-flex>

              <v-flex xs12 md6>
                <div>Tax ID</div>
                <v-text-field solo v-model="Location.DCALicense" label="Enter tax id 99-9999999" hide-details>
                </v-text-field>
              </v-flex>

              <v-flex xs12 md6>
                <div>Email Address</div>
                <v-text-field solo v-model="Location.email" :error-messages="locationEmailErrors"
                  :hide-details="locationEmailErrors.length === 0" label="Enter email address">
                </v-text-field>
              </v-flex>

              <v-flex xs12>
                <div>Select Time Zone</div>
                <v-autocomplete solo :items="timeZones" label="Time Zone" item-text="label" item-value="tzCode"
                  v-model="Location.timeZone">
                </v-autocomplete>
              </v-flex>

            </v-layout>




            <h4>Address</h4>

            <v-layout row wrap>
              <!-- <v-flex xs12 sm6 md6>
                <v-text-field type="text" solo data-cy="newOrganizationLocationAddressType"
                  v-model="Location.Address.type" @focus="$event.target.select()" :label="$t('labels.type')"
                  hint="ie. Home, Office, Business"></v-text-field>
              </v-flex> -->

              <v-flex xs12 sm6 md6>
                <div>Phone Number</div>
                <v-text-field type="text" solo v-model="Location.Address.phoneNumber" @focus="$event.target.select()"
                  hide-details label="Enter phone number"></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <div>Street Address</div>
                <v-text-field type="text" solo :background-color="`${Location.Address.addressLine1 ? false : '#E8E2F2'
                  }`" v-model="Location.Address.addressLine1" :error-messages="addressLine1Errors"
                  label="Enter your location street address" :hide-details="addressLine1Errors.length === 0"
                  @focus="$event.target.select()" @input="$v.Location.Address.addressLine1.$touch()"></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <div>Address Line 2</div>
                <v-text-field type="text" solo v-model="Location.Address.addressLine2" hide-details
                  @focus="$event.target.select()" label="Store number"></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <div>City</div>
                <v-text-field solo :background-color="`${Location.Address.city ? false : '#E8E2F2'}`" type="text"
                  v-model="Location.Address.city" :error-messages="cityErrors" label="Enter city"
                  :hide-details="cityErrors.length === 0" @focus="$event.target.select()"
                  @input="$v.Location.Address.city.$touch()"></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <div>Select State</div>
                <v-autocomplete solo :background-color="`${Location.Address.StateId ? false : '#E8E2F2'}`"
                  :items="states" label="Select state" :hide-details="stateIdErrors.length === 0"
                  :error-messages="stateIdErrors" item-text="name" item-value="id"
                  v-model="Location.Address.StateId"></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <div>Zip Code</div>
                <v-text-field solo :background-color="`${Location.Address.postalCode ? false : '#E8E2F2'}`" type="text"
                  :error-messages="postalCodeErros" v-model="Location.Address.postalCode"
                  :hide-details="postalCodeErros.length === 0" label="Enter zip code"></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <div>Country</div>
                <v-autocomplete solo :background-color="`${Location.Address.CountryCode ? false : '#E8E2F2'}`"
                  :items="countries" :error-messages="countryCodeErrors" :hide-details="countryCodeErrors.length === 0"
                  label="Select Country" item-text="name" item-value="code"
                  v-model="Location.Address.CountryCode"></v-autocomplete>
              </v-flex>

              <v-flex xs12>
                <div>Description</div>
                <v-textarea name="input-7-1" :label="$t('labels.description')" auto-grow solo
                  v-model="Location.Address.description"></v-textarea>
              </v-flex>

              <v-layout>
                <v-btn flat large @click="prevStage">back</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" large class="white-btn v-btn-with-radius" :disabled="$v.Location.$invalid"
                  @click="nextStage">continue</v-btn>
              </v-layout>
            </v-layout>
          </v-container>
        </v-card>

        <v-card flat class="outlined" v-if="stage === 3">
          <v-container>
            <div>
              <h2>Select sign-up type</h2>

              <v-radio-group v-model="selectedPlan" :mandatory="false">
                <v-radio data-cy="newOrganizationPlans" v-for="item in plans" :key="item.id" v-if="item.id !== 1"
                  :label="item.name" :value="item"></v-radio>
              </v-radio-group>




              <v-layout column align-center justify-center v-show="selectedPlan && parseFloat(selectedPlan.amount) > 0">
                <h4 class="my-2">Payment Method</h4>

                <v-card max-width="500px" min-width="300px" class="outlined mt-2" flat>
                  <!-- <v-card-title v-if="selectedPlan && selectedPlan.trialDays">
                    You will not be charged until
                    {{
                      selectedPlan.trialDays > 1
                        ? `${selectedPlan.trialDays} days`
                        : `${selectedPlan.trialDays} day`
                    }}
                    from today. <br />You may cancel at any time.
                  </v-card-title> -->
                  <v-card-text>
                    <card class="stripe-card my-3" :class="{ complete }" :stripe="stripePublicKey"
                      @change="complete = $event.complete" />
                    <img class="my-2" src="../../assets/images/powered_by_stripe.svg" height="26px" />
                  </v-card-text>
                </v-card>

                <v-layout row justify-center class="mt-2">
                  <img class="my-2" src="../../assets/images/visa.svg" height="26px" />
                  <img class="my-2" src="../../assets/images/mastercard.svg" height="26px" />
                  <img class="my-2" src="../../assets/images/discovercard.svg" height="26px" />
                  <img class="my-2" src="../../assets/images/americanexpress.svg" height="26px" />
                </v-layout>
              </v-layout>

              <v-flex style="font-size: 12px; color:black" class="ma-3 black--text">
                <p>
                  Your Auto Repair Desk subscription will start once you click “Create Organization.” By clicking the
                  button, you
                  agree to the following: (i) your subscription will renew automatically each month, and (ii) the
                  payment method you
                  provided will be charged monthly, unless you decide to cancel. To cancel, just reach out to us at
                  <b>info@autorepairdesk.com</b>.

                </p>
                <p>
                  Please note, subscription fees are billed monthly in advance, and we don’t offer credits or refunds
                  for partial or
                  prepaid months after cancellation. Also, prices, fees, features, services, and offers may change at
                  any time without
                  prior notice. Thank you for choosing Auto Repair Desk!

                </p>

                <p>
                  By clicking, “Create Organization”, I confirm that I am over 13 and have
                  read the
                  <a href="https://www.autorepairdesk.com/termsandcondition/">Terms of Use</a>.
                </p>
              </v-flex>
            </div>

            <!-- <div v-else>
              You're all set. Confirm the terms and condition to finalize your sign up.
            </div> -->
            <v-divider></v-divider>
            <v-layout class="mt-3">
              <v-btn flat large @click="prevStage">back</v-btn>
              <v-spacer></v-spacer>
              <v-btn flat to="/login">{{
                $t('buttons.cancel')
              }}</v-btn>
              <v-btn color="primary" @click="submit" :loading="isLoading">{{
                $t('buttons.createOrganization') }}</v-btn>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { Card, createToken } from 'vue-stripe-elements-plus'
import { mapGetters, mapActions } from 'vuex'
import timezones from 'compact-timezone-list'
import publicService from '@/api/public'
import organizationService from '../Organization/service.js'

const { validationMixin } = require('vuelidate')
const { required, minLength, email } = require('vuelidate/lib/validators')

export default {
  name: 'new-organization',
  data() {
    return {
      stage: 1,
      clientEmail: process.env.VUE_APP_CLIENT_EMAIL,
      clientName: process.env.VUE_APP_CLIENT_NAME,
      complete: false,
      stripePublicKey: process.env.VUE_APP_STRIPE_PK,
      isLoading: false,
      ReferralCode: null,
      timeZones: timezones,
      Organization: {
        name: null,
        phoneNumber: null,
        email: null,
        cardToken: null,
      },
      plans: [],
      selectedPlan: null,
      Location: {
        name: null,
        type: null,
        website: null,
        DCALicense: null,
        timeZone: this.$moment.tz.guess() || 'America/New_York',
        email: null,
        Address: {
          name: null,
          addressLine1: null,
          addressLine2: null,
          addressLine3: null,
          city: null,
          StateId: null,
          CountryCode: 840,
          phoneNumber: null,
        },
      },
      taxTemplate: {
        name: null,
        autoApply: false,
        symbol: null,
        type: 'PERCENTAGE',
        percentage: null,
        amount: null,
      },
    }
  },
  components: {
    Card,
  },
  created() {
    publicService
      .GetPlans({
        planId: this.$route.params.plan,
        audience: 'LOCATION',
        includeIntegrations: true,
      })
      .then((response) => {

        this.plans = response.data
        if (this.$route.params.plan && response.data.length > 0) {
          this.Location.planId = this.$route.params.plan
        }
        // console.log('response.data[1]', response.data[1])
        this.selectedPlan = response.data[1]
      })
  },

  watch: {
    async selectedPlan(val) {
      if (val.name === 'Partner') {
        const { value: password } = await this.$swal.fire({
          title: 'Enter your password',
          input: 'password',
          inputLabel: 'Password',
          icon: 'question',
          inputPlaceholder: 'Enter your password',
          confirmButtonColor: '#D32F2F',
          confirmButtonText: 'Save',
          inputAttributes: {
            maxlength: 13,
            autocapitalize: 'off',
            autocorrect: 'off',
          },
        })

        if (password !== 'pakistan@100%') {
          this.$swal.fire({
            confirmButtonColor: '#D32F2F',
            icon: 'error',
            title: 'Partner Sing up',
            text: 'Wrong Password',
          })
          // this.$swal.fire('Wrong Password')
          // console.log('this.plans[0]', this.plans[0])
          this.selectedPlan = this.plans[1]
        }
      }
    },
    stage(val) {
      if (val === 2) {
        console.log('this.$refs', this.$refs)
        setTimeout(() => {
          if (this.$refs.businessName) {
            this.$refs.businessName.focus()
          }
        }, 300);

        // this.$refs.businessName.focus()
        console.log('Organization', this.Organization)
        this.Location.email = this.Organization.email
        this.Location.name = this.Organization.name
        this.Location.Address.phoneNumber = this.Organization.phoneNumber
      }
    }
  },
  methods: {
    ...mapActions('global', ['initOrganization']),
    prevStage() {
      this.stage--
    },
    nextStage() {
      this.stage++
    },
    async submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$toasted.error('Invalid Input', {
          position: 'top-right',
          showHideTransition: 'slide',
          duration: 2000,
        })
      } else if (
        !this.complete &&
        this.selectedPlan &&
        parseFloat(this.selectedPlan.amount) > 0
      ) {
        this.$toasted.error('Card is required.', {
          position: 'top-right',
          showHideTransition: 'slide',
          duration: 2000,
        })
      } else {
        this.isLoading = true
        // If card was added then we need to create the token before creating the organization
        if (this.complete) {
          const data = await createToken()
          this.Organization.cardToken = data.token.id
        }

        // Check if plan was selected
        if (this.selectedPlan) {
          this.Location.planId = this.selectedPlan.planId
        }
        organizationService
          .create({
            ReferralCode: this.ReferralCode,
            Organization: this.Organization,
            Location: this.Location,
          })
          .then((response) => {
            return this.initOrganization(response.data)
              .then(() => {
                this.$router.push({ path: '/' })
              })
              .catch((error) => {
                console.log(error)
              })
            this.isLoading = false
          })
          .catch((error) => {
            console.log(error)
            this.$toasted.error(error.data.message, {
              position: 'top-right',
              showHideTransition: 'slide',
              icon: 'error',
              duration: 4000,
            })
            this.isLoading = false
          })
      }
    },
  },
  computed: {
    ...mapGetters('global', ['states', 'countries', 'defaultCountryCode']),
    organizationNameErrors() {
      const errors = []
      if (!this.$v.Organization.name.$dirty) return errors
      if (!this.$v.Organization.name.required)
        errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Organization.name.minLength)
        errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
    organizationPhoneNumberErrors() {
      const errors = []
      if (!this.$v.Organization.phoneNumber.$dirty) return errors
      if (!this.$v.Organization.phoneNumber.required)
        errors.push(this.$t('validations.phoneNumberIsRequired'))
      if (!this.$v.Organization.phoneNumber.minLength)
        errors.push(this.$t('validations.invalidPhoneNumber'))
      return errors
    },
    organizationEmailErrors() {
      const errors = []
      if (!this.$v.Organization.email.$dirty) return errors
      if (!this.$v.Organization.email.required)
        errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Organization.email.email)
        errors.push(this.$t('validations.emailIsNotValid'))
      return errors
    },
    locationNameErrors() {
      const errors = []
      if (!this.$v.Location.name.$dirty) return errors
      if (!this.$v.Location.name.required)
        errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Location.name.minLength)
        errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
    locationEmailErrors() {
      const errors = []
      if (!this.$v.Location.email.$dirty) return errors
      if (!this.$v.Location.email.email)
        errors.push(this.$t('validations.emailIsNotValid'))
      return errors
    },
    addressLine1Errors() {
      const errors = []
      if (!this.$v.Location.Address.addressLine1.$dirty) return errors
      if (!this.$v.Location.Address.addressLine1.minLength)
        errors.push(this.$t('validations.addressMustHaveAtleast2Characters'))
      if (!this.$v.Location.Address.addressLine1.required)
        errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    cityErrors() {
      const errors = []
      if (!this.$v.Location.Address.city.$dirty) return errors
      if (!this.$v.Location.Address.city.required)
        errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    postalCodeErros() {
      const errors = []
      if (!this.$v.Location.Address.postalCode.$dirty) return errors
      if (!this.$v.Location.Address.postalCode.required)
        errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    stateIdErrors() {
      const errors = []
      if (!this.$v.Location.Address.StateId.$dirty) return errors
      if (!this.$v.Location.Address.StateId.required)
        errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    countryCodeErrors() {
      const errors = []
      if (!this.$v.Location.Address.CountryCode.$dirty) return errors
      if (!this.$v.Location.Address.CountryCode.required)
        errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
  },
  mixins: [validationMixin],
  validations: {
    Organization: {
      name: {
        required,
        minLength: minLength(4),
      },
      phoneNumber: {
        required,
        minLength: minLength(10),
      },
      email: {
        required,
        email,
      },
    },
    Location: {
      name: {
        required,
        minLength: minLength(4),
      },
      email: {
        email,
      },
      Address: {
        addressLine1: {
          required,
          minLength: minLength(2),
        },
        city: {
          required,
        },
        postalCode: {
          required,
        },
        StateId: {
          required,
        },
        CountryCode: {
          required,
        },
      },
    },
  },
}
</script>
